module.exports = __webpack_public_path__ + "img/ep2-9.c7f0a034.png";